import React from 'react';
import { CustomModal } from '@components/ui/modal/CustomModal';
import { CustomButton } from '@components/ui/button/CustomButton';

// ─── Props ────────────────────────────────────────────────────────────────────

export interface PanelVerificationNoticeProps {
  isOpen: boolean;
  onClose: () => void;
}

// ─── Component ────────────────────────────────────────────────────────────────

/**
 * Lo que ve quien no puede verificar el panel (ni owner ni super admin) al
 * intentar una acción bloqueada o tocar el chip. Copy provisional: no hay
 * frame en el Figma para este caso.
 */
export const PanelVerificationNotice: React.FC<
  PanelVerificationNoticeProps
> = ({ isOpen, onClose }) => (
  <CustomModal
    isOpen={isOpen}
    onClose={onClose}
    title="Tu panel está pendiente por verificación"
    showFooterDivider={false}
    buttons={<CustomButton label="Entendido" onPress={onClose} />}
  >
    <p className="text-body-2 text-fg-secondary">
      Para realizar esta acción, el panel tiene que estar verificado. Contacta
      al administrador del panel para que complete la verificación.
    </p>
  </CustomModal>
);
